(() => {
  // Publish privacy-safe B2B events to the existing GTM dataLayer.
  // Never include values typed into the inquiry form.
  window.dataLayer = window.dataLayer || [];

  const params = new URLSearchParams(window.location.search);
  const pagePath = `${window.location.pathname}${window.location.hash || ''}`;
  const sourceData = {
    page_path: pagePath,
    page_type: document.body?.dataset?.pageType || '',
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_content: params.get('utm_content') || '',
    utm_term: params.get('utm_term') || ''
  };

  const pushEvent = (event, detail = {}) => {
    window.dataLayer.push({ event, ...sourceData, ...detail });
  };

  const getInquiryContext = (link) => {
    const designRoot = link.closest('[data-ziloop-design]');
    const productInquiry = link.closest('.ziloop-product-inquiry');
    const productTitle = designRoot?.dataset.productTitle ||
      productInquiry?.closest('.product__info-wrapper')?.querySelector('.product__title')?.textContent?.trim() ||
      document.querySelector('main .product__title')?.textContent?.trim() || '';

    return {
      inquiry_context: designRoot ? 'design_preview' : productInquiry ? 'product_detail' : 'sitewide',
      product_name: productTitle,
      design_selection: designRoot?.querySelector('[data-design-choice][aria-pressed="true"]')?.dataset.label || ''
    };
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const context = getInquiryContext(link);
    if (/^mailto:/i.test(href)) {
      pushEvent('b2b_inquiry_click', { ...context, inquiry_method: 'email' });
    } else if (/wa\.me\//i.test(href) || /api\.whatsapp\.com/i.test(href)) {
      pushEvent('b2b_inquiry_click', { ...context, inquiry_method: 'whatsapp' });
    } else if (/\/pages\/contact(?:[?#]|$)/i.test(href) || /#ZiloopB2BRFQ/i.test(href)) {
      pushEvent('b2b_quote_cta_click', { ...context, inquiry_method: 'rfq_form' });
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const choice = target?.closest('[data-design-choice]');
    const root = choice?.closest('[data-ziloop-design]');
    if (!choice || !root) return;

    pushEvent('b2b_design_selection', {
      product_name: root.dataset.productTitle || '',
      design_selection: choice.dataset.label || ''
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'ZiloopB2BRFQ') return;

    // Submit fires only after native required-field validation passes.
    // Keep all visitor-entered field values out of analytics.
    pushEvent('b2b_rfq_submit', {
      inquiry_context: 'rfq_form',
      inquiry_method: 'email_form'
    });
  });
})();
